import {
    Accordion,
    AccordionItem,
} from "@pacificoseguros/pixie/react/accordion";
import classnames from "classnames";
import React, { memo, useCallback, useState } from "react";
import { SizedBox } from "../../../components/layout/sized-box";
import { SpacingBox } from "../../../components/layout/spacing-box";
import { Typography } from "../../../components/typography/typography";
import { useWindowResize } from "../../../hooks/use-windows-resize";

const faqItems = [
    {
        question: <span>¿El seguro cuenta con exclusiones?</span>,
        answer: (
            <span>
                El seguro Vida Ley no cuenta con exclusiones. No obstante, no se
                cubre el fallecimiento o invalidez que se produjera como
                consecuencia de suicidio o de lesiones autoinferidas, siempre y
                cuando estas situaciones no generen un supuesto de muerte
                natural, muerte accidental ni de invalidez total y permanente
                por accidente del Asegurado.
            </span>
        ),
    },
    {
        question: (
            <span>
                ¿Cuál es el procedimiento para actualizar la planilla de
                trabajadores?
            </span>
        ),
        answer: (
            <span>
                Directamente a través de nuestra web, ingresando a Pacífico en
                Línea con tu usuario y clave. Este aplicativo permite cargar una
                hoja Excel con la información básica de tus trabajadores
                (Nombres, Apellido Paterno, Apellido Materno, Documento de
                identidad, Fecha de Nacimiento, Nacionalidad y Remuneración
                Asegurable), y emitir en el momento la liquidación y constancia
                de cobertura del periodo declarado.<br></br>
                <br></br>Si no tienes usuario en Pacífico en Línea, lo podrás
                solicitar al siguiente correo electrónico:
                webvidagrupo@grupopacifico.com.pe, indicando los siguientes
                datos: Nombre, DNI y correo electrónico del Usuario. Te
                responderemos en un lapso de 2 días hábiles haciéndote llegar tu
                usuario web, clave de acceso y manual de uso.
            </span>
        ),
    },
    {
        question: (
            <span>¿Qué documentos debo presentar en caso de un siniestro?</span>
        ),
        answer: (
            <span>
                En caso de <b>muerte natural del asegurado</b>, el empleador
                debe contactarse con Pacífico y presentar los siguientes
                documentos:
                <br></br>
                <br></br>- Partida o acta de defunción legalizada.<br></br>-
                Certificado médico de defunción completo legalizado.<br></br>-
                Declaración jurada de beneficiarios.<br></br>- Partida de
                matrimonio.<br></br>- Documento de identidad del asegurado y de
                los beneficiarios.<br></br>- Boleta de pago correspondiente a
                los tres (3) últimos meses previos al fallecimiento; en caso que
                el asegurado sea obrero, las boletas de pago correspondientes a
                las doce (12) últimas semanas previas al fallecimiento.<br></br>
                <br></br>En caso de{" "}
                <b>
                    muerte accidental del asegurado o invalidez total o
                    permanente{" "}
                    <a
                        href="https://www.pacifico.com.pe/seguros/vida-ley/como-usar"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <Typography variant="secondary" decoration="underline">
                            ingrese aquí
                        </Typography>
                    </a>
                </b>
            </span>
        ),
    },
];

export const LandingFaqSection = memo(() => {
    const [openedItemIndex, setOpenedItemIndex] = useState<number>(0);
    const { isMobile } = useWindowResize();
    const handleExpand = useCallback((index) => {
        setOpenedItemIndex(index);
    }, []);
    const handleCollapse = useCallback(() => {
        setOpenedItemIndex(null);
    }, []);
    return (
        <SizedBox
            data-testid="LandingFaqSection"
            className="landing-faq-section"
            width={isMobile ? 320 : 668}
        >
            <SpacingBox mt={50} />
            <Typography variant="secondary" fontSize={23}>
                <b>Preguntas frecuentes</b>
            </Typography>
            <SpacingBox mt={30} />
            <Accordion>
                {faqItems.map((item, i) => (
                    <AccordionItem
                        expanded={openedItemIndex === i}
                        onExpand={() => handleExpand(i)}
                        onCollapse={handleCollapse}
                        key={i}
                        className={classnames({
                            closed: openedItemIndex !== i,
                        })}
                    >
                        <p slot="title">
                            <Typography fontSize={16}>
                                {item.question}
                            </Typography>
                        </p>
                        <section slot="content">{item.answer}</section>
                    </AccordionItem>
                ))}
            </Accordion>
        </SizedBox>
    );
});

LandingFaqSection.displayName = "LandingFaqSection";
